import { Injectable } from '@angular/core';

import { ScheduleEvent, ScheduleViewModel } from '../models/ScheduleModels';
import { catchError, Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BaseService } from './baseservice';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService  extends BaseService{

  constructor(private http: HttpClient) {
    super();
   }

   getSchedule(year: number, month: number): Observable<ScheduleViewModel>{
    //console.log('hå');
    let ret = this.http.get<ScheduleViewModel>(this.rootUrl + '/api/scouting/schedule/' + year + "/" + month );
    return ret;
   }

  getScheduleComing(): Observable<ScheduleViewModel> {
    //console.log('hå');
    return this.http.get<ScheduleViewModel>(this.rootUrl + '/api/scouting/schedule/comingup').pipe(
      catchError(this.handleError)
    );

  }

  getScheduleWeek(year: number, month: number, day: number): Observable<ScheduleViewModel> {
    //console.log('hå');
    let ret = this.http.get<ScheduleViewModel>(this.rootUrl + '/api/scouting/schedule/GetCalendarWeek/' + year + "-" + month + "-" + day);
    return ret;
  }


   

   addGameToSchedule(GameId: string, EventStart: Date, Comment: string, Visibility: boolean ){
     var params = {
       GameId: GameId,
       EventStart: EventStart,
       Comment: Comment,
       Visibility: Visibility

     }
      return this.http.post<boolean>(this.rootUrl + '/api/scouting/schedule/addgame', params);     
   }

   
   removeEventFromSchedule(EventId: string){
    var params = {
      EventId: EventId
    }
    
    return this.http.post<boolean>(this.rootUrl + '/api/scouting/schedule/removeevent', params);
   }

  addGenericEvent(event: ScheduleEvent) {
    return this.http.post<boolean>(this.rootUrl + '/api/scouting/schedule/event', event);
  }

  updateGenericEvent(event: ScheduleEvent) {
    // console.log(event);
    return this.http.put<boolean>(this.rootUrl + '/api/scouting/schedule/event', event);
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      // console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      // console.error(
      //   `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    // console.log("rethrowing error", error);
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }

}
